/**
 * 带过期时间的本地存储工具类
 */
class Storage {
  constructor(_expires = 12 * 60 * 60 * 1000) {
    // 默认12小时过期
    this._expires = _expires
  }

  set(key, value) {
    const item = {
      value,
      _timestamp: new Date().getTime(),
      _expires: this._expires,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }

  get(key) {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) return null

    const item = JSON.parse(itemStr)
    const now = new Date().getTime()

    if (now - item._timestamp > item._expires) {
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }

  remove(key) {
    localStorage.removeItem(key)
  }

  clear() {
    localStorage.clear()
  }
}

export const storage = new Storage()
export default Storage
